import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.u73_1 = partyId;
        this.v73_1 = pinId;
        this.w73_1 = icon;
        this.x73_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.u73_1.toString() + ', pinId=' + this.v73_1.toString() + ', icon=' + this.w73_1 + ', name=' + this.x73_1 + ')';
      }
      hashCode() {
        var result = this.u73_1.hashCode();
        result = imul(result, 31) + this.v73_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.w73_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x73_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.u73_1.equals(other.u73_1))
          return false;
        if (!this.v73_1.equals(other.v73_1))
          return false;
        if (!(this.w73_1 === other.w73_1))
          return false;
        if (!(this.x73_1 === other.x73_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
